/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.activityModule')
.controller('ActivityController', ['$state', 'BulbActivityService', 'BulbAuthService', 'BulbModalService', 'BulbPageService', 'AUTH', ActivityController]);

/**
 * The controller for our activity feed.
 */
function ActivityController($state, BulbActivityService, BulbAuthService, BulbModalService, BulbPageService, AUTH){

  var that = this;

  /**
   * Prevent ADMIN users from interacting with the activity feed when using 'sign in as' to diagnose problems.
   */
  if(BulbAuthService.currentUser.hasRole(AUTH.ROLES.SWITCHED_USER)){
    that.switchedUser = true;
  }

  this.activityFeed = BulbActivityService.activityFeed;

  /**
   * Initiates the create collection flow.
   *
   * Currently, the only allowed parent for a collection is the author page.
   */
  this.createCollection = function() {
    $state.go('createCollection');
  };

  /**
   * Create a new page as a child of the author page.
   *
   * DO LATER : a virtually identical method exists in the composite view controller.  Probably want to unify them.
   */
  this.createPage = function() {
    BulbPageService.createPage(BulbAuthService.currentUser.authorUnitId);
  };

  /**
   * Show the off-boarding popup modal to be actioned.
   */
  this.showOffBoardingModal = function() {
    if (BulbAuthService.currentUser.prefs.offBoarding !== null || !that.switchedUser) {
      // Show the offboarding modal for the seniors
      var modalOptions = {
        headerTemplateUrl: 'ajs/components/offboarding/offboarding-fontawesome.html',
        titleCode: 'off_board_modal_header',
        template: '<bulb-offboarding></bulb-offboarding>',
        windowClass: 'updated-modal-design bulb-offboarding-alert-modal',
        backdrop: 'static',
        closeOnClick: true,
        showOkButton: false,
        showCancelButton: false
      };
      BulbModalService.open(modalOptions);
    }
  };
}


